import keyBy from 'lodash/keyBy'
import map from 'lodash/map'
import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { useUser } from '@ztechapps/common.hook'
import { QueryBuilderInput } from '../../../QueryBuilder'
import { humanize } from '@ztechapps/common.utils'

export const QueryTemplateInputValue = ({ filterFields }) => {
  const [config, setConfig] = React.useState(null)

  //add the user, need to get the timezone to use on date guery builder
  const { user } = useUser()

  //we need to convert this fieldFields to props config of query builder
  React.useEffect(() => {
    const fromFilterFields = map(filterFields, (e) => {
      return {
        ...e,
        _id: e?._id ?? e.name,
        label: e.displayName ?? humanize(e.name),
        type: e.type ?? 'text',
        valueSources: ['value'],
      }
    })
    const newConfig = {
      fields: keyBy(fromFilterFields, '_id'),
    }
    setConfig(newConfig)

    //map the value for filter fields
  }, [filterFields])

  return (
    <Field
      {...{
        name: 'filter',
        label: 'Value',
        config,
        component: QueryBuilderInput,
        onChange: true,
        timeZone: user?.timeZone,
      }}
    />
  )
}
